import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zMc2Settings = z.object({
  objMcId: zUid.nullish(),
  objSizeLineId: zUid.nullish(),
  objSizeLineSizeId: zUid.nullish(),
  objSizeId: zUid.nullish(),
  objPointId: zUid.nullish(),
  mcAttrNameId: zUid.nullish(),
  mcAttrSizeLineNameId: zUid.nullish(),
  mcAttrCommentId: zUid.nullish(),
  mcAttrImgAttrId: zUid.nullish(),
  mcAttrBaseSizeAttrId: zUid.nullish(),
  mcAttrLinkToModelAttrId: zUid.nullish(),
  mcAttrLinkToSizeLineId: zUid.nullish(),
  sizeLineAttrLinkToSizeLineSizeId: zUid.nullish(),
  sizeLinkToSizeLineAttrId: zUid.nullish(),
  sizeLineSizeAttrLinkToPreviousSizeId: zUid.nullish(),
  sizeLineSizeAttrLinkToSizeNamesId: zUid.nullish(),
  sizeNamesAttrNameId: zUid.nullish(),
  pointAttrNameId: zUid.nullish(),
  pointAttrDescriptionId: zUid.nullish(),
});
export type ZMc2Settings = z.infer<typeof zMc2Settings>;

export type Mc2ObjField = keyof Pick<
  ZMc2Settings,
  "objMcId" | "objPointId" | "objSizeId" | "objSizeLineId" | "objSizeLineSizeId"
>;

export const zMc2 = z.object({
  id: zUid,
  stateId: zUid.nullish(),
  name: z.string(),
  sizeLineId: zUid.nullish(),
  sizeLineName: z.string().nullish(),
  comment: z.string().nullish(),
  images: zUid.array().nullish(),
  baseSize: z.string().nullish(),
  permissions: z.string().array().nullish(),
});
export type ZMc2 = z.infer<typeof zMc2>;

export type Mc2Fields = Omit<ZMc2, "id">;

export type FilterMc2 = {};
